import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20warm%20gradient%20abstract%20background%20with%20soft%20book%20pages%20floating%2C%20reading%20culture%20artistic%20minimalist%20design%2C%20cream%20and%20terracotta%20tones%2C%20gentle%20light%20rays%2C%20dreamy%20atmosphere&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 to-primary-800/75"></div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2
          className="text-2xl md:text-4xl font-bold text-background-50 mb-4"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          找到属于你的那部韩国漫画
        </h2>
        <p className="text-background-200/90 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          我们精心挑选了<strong className="text-background-50">500+</strong>部优质<strong>韩国漫画</strong>，
          覆盖恋爱、奇幻、悬疑、搞笑等全类型，只为帮你找到最爱的那一部。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-7 py-3 bg-background-50 text-primary-700 rounded-full font-semibold text-sm hover:bg-background-100 transition-all cursor-pointer no-underline whitespace-nowrap"
          >
            立即探索
            <i className="ri-compass-3-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 border border-background-50/30 text-background-50 rounded-full font-medium text-sm hover:bg-background-50/10 transition-all cursor-pointer no-underline whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}